import { type JSX } from 'react';
import { CustomControlCode } from '@common/enums';
import { holterExternalExaminationRequestSections } from '@common/validation/customControls/cardiology/holter/holterExternalExaminationRequestSchemas';
import { getPsDataInputComponents } from '@frontend/components/pages/customControls/utils/v1/labResults/getPsDataInputComponents';
import { EditForm } from '@frontend/formEngine/editForm/EditForm';
import { getPatientContactDetailsComponent } from '../../../patientContactDetails/getPatientContactDetailsComponent';
import { HolterExaminationFollowingSteps } from '../customComponents/HolterExaminationFollowingSteps';
import { getExaminationRequestContentComponents } from '../utils/getExaminationRequestContentComponents';
import { getExaminationRequestInputComponentsBase } from '../utils/getExaminationRequestInputComponentsBase';
import { getMedicationInputComponents } from '../utils/getMedicationInputComponents';
import { getRecipientDataInputComponents } from '../utils/getRecipientDataInputComponents';
import { getReferralDataInputComponents } from '../utils/getReferralDataInputComponents';

export function HolterExternalExaminationRequestEdit(): JSX.Element {
    const inputComponents = new Map([
        ...getExaminationRequestInputComponentsBase(),
        ...getMedicationInputComponents(),
        ...getPsDataInputComponents(),
        ...getPatientContactDetailsComponent({ showAddress: false }),
        ...getReferralDataInputComponents(),
        ...getRecipientDataInputComponents(),
    ]);

    return (
        <>
            <EditForm
                contentComponents={getExaminationRequestContentComponents()}
                inputComponents={inputComponents}
                sections={holterExternalExaminationRequestSections}
            />
            <HolterExaminationFollowingSteps holterType={CustomControlCode.HolterExternalExaminationRequest} />
        </>
    );
}
